<div id="wrapper">
    <div class="allcont">
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
        <div>
            <app-tab-nav 
                (updatePostpaid)="this.postpago=$event" 
                (updatePrepaid)="this.prepago=$event"
                (updateFixed)="this.telefoniaFijo=$event" 
                (updateTotalAccountList)="this.totalAccountList=$event"
                (updateCurrentList)="this.currentList=$event" 
                (updateSelectBan)="this.selectBan=$event"
                (updateInitializeData)="this.initializeData()">
            </app-tab-nav>
        </div>
        <div class="basicrow">
            <div class="container">
                <div class="basicr-line-i">
                    <div class="fulltitle m-top-i f-btitle autodef">
                        <span class="icon-dash-24"></span> Recarga de Prepago
                    </div>
                    <div class="pull-right"></div>
                </div>
            </div>
        </div>
        <div class="basicrow mbott m-top" id="last-div" *ngIf="this.prepago==true">
            <div class="container" *ngIf="this.screenView==1">
                <app-top-up-balance 
                    (updateScreenView)="this.screenView=$event" 
                    (updateAmount)="this.amount=$event"
                    (updateIdProduct)="this.idProduct=$event" 
                    (updateTax)="this.tax=$event"
                    (updateTotalAmount)="this.totalPagar=$event">
                </app-top-up-balance>
            </div>
            <div class="container" *ngIf="this.screenView==2">
                <app-confirmation-recharge 
                    (updateScreenView)="this.screenView=$event"
                    (updateIdTransaction)="this.idTransaction=$event"
                    (updateIdTransactionRecarga)="this.idTransactionRecarga=$event"
                    [tax]="this.tax"
                    [amount]="this.amount" 
                    [totalPagar]="this.totalPagar">
                </app-confirmation-recharge>
            </div>
            <div class="container" *ngIf="this.screenView==3">
                <app-payment-recharge 
                    (updateScreenView)="this.screenView=$event"
                    (updateInitializeData)="this.initializeData()" 
                    (updateTotal)="this.total=$event"
                    (updateTotalAmount)="this.totalPagar=$event" 
                    [amount]="this.amount"
                    [idProduct]="this.idProduct"
                    [totalPagar]="this.totalPagar" 
                    (updateIdTransactionRecarga)="this.idTransactionRecarga=$event"
                    (updateIdTransaction)="this.idTransaction=$event">
                </app-payment-recharge>
            </div>
            <div class="container" *ngIf="this.screenView==4">
                <app-confirm-send-recharge [idTransactionRecarga]="this.idTransactionRecarga"
                    [idTransaction]="this.idTransaction" [total]="this.totalPagar"
                    (updateInitializeData)="this.initializeData()" ></app-confirm-send-recharge>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>